import React from "react";
import type { PackageType } from "../../type/package";
import { PackageIcon } from "../packageIcon/packageIcon";
import type { UserPackageBadgeModel } from "../../type/settings";


const normalizePackageType = (
  name?: string | null
): PackageType => {
  if (!name) return "none";

  const normalized = name.toLowerCase() as PackageType;
  return normalized;
};

export const UserPackageBadge: React.FC<UserPackageBadgeModel> = ({
  packageName,
  iconWidth = 38,
  iconHeight = 32,
  className = "user-package-group",
}) => {
  const packageType = normalizePackageType(packageName);

  return (
    <div className={className}>
      Package:
      <PackageIcon
        type={packageType}
        width={iconWidth}
        height={iconHeight}
      />
      {packageName || "None"}
    </div>
  );
};
